import React from 'react';
import { useTranslation } from '../../i18n/provider';
import styles from './FoodHistorySection.module.css';

type DaySummary = {
  title: string;
  date: string;
  metGoal: boolean;
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
};

type Props = {
  goalCalories: number;
  days: DaySummary[];
  onSelectDay: (date: string, title: string) => void;
};

const FoodHistorySection: React.FC<Props> = ({ goalCalories, days, onSelectDay }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{t('food.history.title')}</h3>
      <div className={styles.list}>
        {days.length === 0
          ? (
            <div className={styles.card}>
              <div className={styles.dayTitle}>{t('food.history.emptyTitle')}</div>
              <div className={styles.target}>
                {t('food.history.emptyHint')}
              </div>
            </div>
          )
          : days.map((d) => (
            <div
              key={d.date}
              className={styles.card}
              style={{ cursor: 'pointer' }}
              onClick={() => onSelectDay(d.date, d.title)}
            >
              <div className={styles.header}>
                <div>
                  <div className={styles.dayTitle}>{d.title}</div>
                </div>
                <div className={`${styles.badge} ${d.metGoal ? styles.badgeMet : styles.badgeMissed}`}>
                  {d.metGoal ? t('food.history.metGoal') : t('food.history.missedGoal')}
                </div>
              </div>

              <div className={styles.macrosRow}>
                <div className={styles.calories}>{d.calories.toLocaleString()} cal</div>
                <div className={styles.macro}>P: {d.protein}g</div>
                <div className={styles.macro}>C: {d.carbs}g</div>
                <div className={styles.macro}>F: {d.fats}g</div>
              </div>

              <div className={styles.target}>
                {t('food.history.target')}: {goalCalories} cal
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FoodHistorySection;
